import React from 'react'
import PropTypes from 'prop-types'
import FilterLabelsRow from '../../../filtersRow/FilterLabelsRow'
import FilterUniButton from '../../../filterUniButton'
import FilterPillsSection from '../../../filterPills/FilterPillsSection'

const CategoryFilters = props => {
  let filterPillsSection

  if (
    props.presentedCategory &&
    props.presentedCategory.planSubcategories.count() > 0
  ) {
    filterPillsSection = (
      <FilterPillsSection filterOptions={props.subcategoryFilterOptions} />
    )
  }

  return (
    <React.Fragment>
      <div className='hidden-xs'>
        <FilterLabelsRow
          filterOptions={props.filterOptions}
          centerContent
          activeDropdown={props.activeCategory}
        />
      </div>
      <div className='visible-xs'>
        <FilterUniButton
          currentlySelectedOption={
            props.presentedCategory && props.presentedCategory.slug
          }
          options={props.categories.map(category => ({
            label: category.title,
            filterValue: category.slug
          }))}
          filterContext='Styles'
          onSelect={selectedVal => {
            props.uniButtonSelect(selectedVal)
          }}
        />
        {filterPillsSection}
      </div>
    </React.Fragment>
  )
}

CategoryFilters.propTypes = {
  activeCategory: PropTypes.string,
  categories: PropTypes.array,
  presentedCategory: PropTypes.object,
  filterOptions: PropTypes.object,
  subcategoryFilterOptions: PropTypes.object,
  uniButtonSelect: PropTypes.func
}

export default CategoryFilters
